import { useState } from 'preact/hooks';
import { useIntl } from 'shared/intl/use-intl';
import { rpx } from 'client/lib/rpx-client';
import { showError } from '@components/app-error';
import { IcoCheckCircle, IcoX } from '@components/icons';
import { Button } from '@components/buttons';

export function ForgotPasswordFooter({
  email,
  onForgotPassword = rpx.auth.forgotPassword,
}: {
  email: string;
  onForgotPassword?: (opts: { email: string; returnURL: string }) => Promise<void>;
}) {
  const [mode, setMode] = useState<'init' | 'sending' | 'sent'>('init');
  const intl = useIntl();

  return (
    <footer class="pt-4 mt-4 border-t flex flex-col gap-4">
      {mode === 'sent' && (
        <div class="bg-green-50 p-4 text-green-800 flex items-center gap-4 rounded-sm">
          <span class="shrink-0">
            <IcoCheckCircle />
          </span>
          <p>{intl('We emailed you a link that will let you continue checkout.')}</p>
          <Button onClick={() => setMode('init')} class="ml-auto">
            <IcoX />
          </Button>
        </div>
      )}
      {mode !== 'sent' && (
        <Button
          class="text-indigo-600"
          isLoading={mode === 'sending'}
          onClick={async () => {
            try {
              setMode('sending');
              await onForgotPassword({
                email,
                returnURL: location.pathname + location.search,
              });
              setMode('sent');
            } catch (err) {
              showError(err);
              setMode('init');
            }
          }}
        >
          {intl('Forgot your password?')}
        </Button>
      )}
    </footer>
  );
}
